import React, { useCallback, useRef, useEffect, useState } from 'react';
import {
  FiLogIn,
  FiMail,
  FiLock,
  FiKey,
  FiMessageCircle,
} from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';
import { rgb } from 'polished';
import {
  FaConnectdevelop,
  FaLock,
  FaHandPointUp,
  FaCertificate,
  FaTicketAlt,
  FaVideo,
  FaAward,
  FaSlideshare,
  FaKey,
} from 'react-icons/fa';
import { MdColorLens, MdMessage } from 'react-icons/md';
import { AiFillSafetyCertificate } from 'react-icons/ai';
import { IconType } from 'react-icons/lib';
import { dadosOrganizacao, logo } from '../../config';
import { ContactIcons, WhatsappIcon } from '../../components/Menu';
import Whatsapp from '../../components/Whatsapp';

import { Container, ContainerWhite } from './styles';

import ShowDiv from '../../components/ShowOnScroll';
import VideoBackground from '../../components/VideoBackground';
import TextPopper from '../../components/TextPopper';
import Scroller from '../../components/Scroller';

import Vimeo from '../../components/Vimeo';

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

const Politica: React.FC = () => {
  return (
    <>
      <ContainerWhite id="termos">
        <div className="p50 p600" style={{ textAlign: 'justify' }}>
          <h2>  Política de Cancelamento e Reembolso – Fórum Atacadista RS</h2>
          <br />

          <p>


            O Sindiatacadistas/RS reserva-se o direito de transferir ou cancelar o evento em caso de força maior. No caso de cancelamento, os valores serão devolvidos.
            <br /><br />
            De acordo com o Código de Defesa do Consumidor (CDC), o comprador tem até 7 dias corridos a partir da data da compra para solicitar o reembolso total do valor do ingresso. Após esse prazo, não haverá devolução dos valores pagos, mesmo em casos de desistência ou não comparecimento.
            <br /><br />
            Caso o participante não possa comparecer ao evento, será permitida a transferência de titularidade do ingresso para outra pessoa, desde que a solicitação seja feita com pelo menos 48 horas antes do início do evento e respeitando o limite de uma transferência por CPF.
            <br /><br />
            A troca deve ser feita diretamente na plataforma de venda de ingressos.     </p>

        </div>
      </ContainerWhite>
    </>
  );
};
export default Politica;
